// Libs
import _omit from 'lodash/omit'

import {
  // Model Properties
  PROP_ID,

  // Action Types
  ADD_SPATIAL,
  UPDATE_SPATIAL,
  REMOVE_SPATIAL,
  CREATE_SPATIAL,
  EDIT_SPATIAL,
  CLEAR_SELECTED_SPATIAL,
  SUBMIT_SPATIIAL,
  TOGGLE_EDIT_SPATIAL,
  TOGGLE_ACTIVE_TOOLS,
} from './constants'

import create from './decode'

export function reduceSpatial (state, { spatial: maybeSpatial }) {
  const spatial = create(maybeSpatial)

  return {
    ...state,
    spatial: {
      ...state.spatial,
      [spatial[PROP_ID]]: spatial,
    },
  }
}

export function modifySpatial (state, { spatial: maybeSpatial }) {
  const spatial = create({
    ...(state.spatial[maybeSpatial && maybeSpatial[PROP_ID]] || {}),
    ...(maybeSpatial || {}),
  })
  const nextState = reduceSpatial(state, { spatial })

  return {
    ...nextState,
    editingSpatial: spatial[PROP_ID],
  }
}

export function removeSpatial (state, { spatial: maybeSpatial }) {
  const spatial = create(maybeSpatial)

  return {
    ...state,
    spatial: _omit(state.spatial, spatial[PROP_ID]),
    editingSpatial: null,
  }
}

export function clearSelectedSpatial (state) {
  return {
    ...state,
    editingSpatial: null,
    spatial: {
      ...state.spatial,
    },
  }
}

export function toggleEditSpatial (state) {
  return {
    ...state, isEditing: !state.isEditing,
  }
}

export function toggleActiveToolsOps (state, isActiveOp) {
  return {
    ...state,
    isActiveToolsOp: isActiveOp,
  }
}

export default {
  [ADD_SPATIAL]: reduceSpatial,
  [UPDATE_SPATIAL]: reduceSpatial,
  [REMOVE_SPATIAL]: removeSpatial,
  [CREATE_SPATIAL]: modifySpatial,
  [EDIT_SPATIAL]: modifySpatial,
  [CLEAR_SELECTED_SPATIAL]: clearSelectedSpatial,
  [SUBMIT_SPATIIAL]: clearSelectedSpatial,
  [TOGGLE_EDIT_SPATIAL]: toggleEditSpatial,
  [TOGGLE_ACTIVE_TOOLS]: toggleActiveToolsOps,
}
